import { OAuthProvider } from '@firebase/auth';
import { environment } from '../../environments/environment';

export const oauthProviderFactory = () => new OAuthProvider(environment.oidcProvider);
